import { gql } from 'apollo-boost';

// User
export const IS_USER_LOGGED_IN = gql`
  query isUserLoggedIn {
    store {
      user(id: "me") {
        id
        email
        emailVerified
        firstName
        lastName
      }
    }
  }
`;

export const CURRENT_USER_QUERY = gql`
  query getCurrentUser {
    store {
      user(id: "me") {
        id
        email
        emailVerified
      }
    }
  }
`

export const REGISTER_USER_QUERY = gql`
  query registerUser {
    store {
      groupIndustries
    }
  }
`;


// Opportunity
export const OPPORTUNITIES_LIST_QUERY = gql`
  query opportunitiesList($id: String!) {
    store {
      group(id: $id) {
        id
        name
        draft
        opportunities: opportunitiesV2(first: 100) {
          id
          name
          status
          campaigns {
            id
            name
          }
        }
        groupsEndorsing {
          id
          endorserId
        }
      }
    }
  }
`;

export const CREATE_OPPORTUNITY_BUTTON_QUERY = gql`
  query createOpportunityButton($groupId: String!, $VRCId: String!) {
    store {
      group(id: $groupId) {
        id
        partnerships(requesteeId: $VRCId) {
          id
          createdAt
          requesteeId
          requesterId
          status
        }
      }
    }
  }
`;


// Group
export const GROUP_QUERY = gql`
  query groupQuery($id: String!) {
    store {
      groupIndustries
      group(id: $id) {
        id
        draft
        name
        summary
        type
        industry
        insuranceStatus
        insurances {
          insuranceType
          vendor
          value
          expiryDate
        }
        insuranceAuspicedOrganisation
        avatarUrl
        bannerUrl
        location {
          id
          address
          locality {
            short
            long
          }
          region {
            short
            long
          }
          country {
            short
            long
          }
          geo {
            lat
            lng
          }
        }
      }
    }
  }
`;

export const GROUPS_LIST_QUERY = gql`
  query groupsList {
    store {
      user(id: "me") {
        id
        email
        groupsAdministered {
          id
          name
          draft
          avatarUrl
        }
      }
    }
  }
`;

export const PARTNERSHIP_STATUS_QUERY = gql`
  query partnershipStatus($requesteeId: String!, $requesterId: String!) {
    store {
      group(id: $requesterId) {
        id
        partnerships(requesteeId: $requesteeId) {
          id
          createdAt
          requesteeId
          requesterId
          status
        }
      }
    }
  }
`;


// Misc
export const SIDEBAR_QUERY = gql`
  query sidebar($groupId: String!) {
    store {
      user(id: "me") {
        id
        firstName
        lastName
      }
      group(id: $groupId) {
        id
        name
      }
    }
  }
`;
